import './Style/main.scss';
import {Router} from "./Shared/Util/Router";

function App() {
    return Router.resolveFromLocation()
}

export default App;
